import DefaultInput from '../DefaultInput'
import { callOnChangeOrSetCheckout } from './fieldHelpers'
import { removeSpaces } from 'Helpers/StringHelpers'

const renderPasswordField = ({ translate, item, onChange }) => (
    <DefaultInput
        type="password"
        label={translate(item.label)}
        value={item.value}
        key={item.key}
        onChange={event => {
            callOnChangeOrSetCheckout(item, removeSpaces(event.target.value, item.key), onChange)
        }}
        showAdornmentLabel={item.args?.onEnroll}
        item={item}
    />
)

export default renderPasswordField

